import { DEMO_BUSINESS_ID } from '@/lib/demo/demoConfig';

export { DEMO_BUSINESS_ID };

/** Textos UI pública demo (badge, subtítulo, powered by). */
export const DEMO_PUBLIC_BRAND = {
  badge: 'Vista previa SoluQR',
  tagline: 'Smash burgers • pedidos inteligentes • experiencia digital',
  poweredBy: 'Powered by SoluQR',
};

/**
 * Imágenes demo: URLs directas images.unsplash.com (sin source.unsplash.com).
 * Parámetros fijos para tamaño/calidad y mejor compatibilidad en embeds.
 */
const IMG = {
  cover:
    'https://images.unsplash.com/photo-1550547660-d9450f859349?w=1200&q=80&auto=format&fit=crop',
  logo:
    'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&q=80&auto=format&fit=crop',
  burger1:
    'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=1200&q=80&auto=format&fit=crop',
  burger2:
    'https://images.unsplash.com/photo-1553979459-b22240ba736b?w=1200&q=80&auto=format&fit=crop',
  burger3:
    'https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?w=1200&q=80&auto=format&fit=crop',
  fries:
    'https://images.unsplash.com/photo-1573080496219-bb080dd4d868?w=1200&q=80&auto=format&fit=crop',
  nuggets:
    'https://images.unsplash.com/photo-1562967914-608f82629710?w=1200&q=80&auto=format&fit=crop',
  shake:
    'https://images.unsplash.com/photo-1572490122747-3968b75cc929?w=1200&q=80&auto=format&fit=crop',
  drink:
    'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=1200&q=80&auto=format&fit=crop',
  combo:
    'https://images.unsplash.com/photo-1594041680534-e8c8cdebd659?w=1200&q=80&auto=format&fit=crop',
};

/** Siempre la misma URL estable (no usar banner_url: puede fallar igual). */
export const DEMO_PRODUCT_IMAGE_FALLBACK_URL =
  'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=1200&q=80&auto=format&fit=crop';

export function getDemoProductImageFallbackUrl(_business) {
  return DEMO_PRODUCT_IMAGE_FALLBACK_URL;
}

/**
 * `onError` para `<img>` en catálogo / upsell / asistente cuando `business.is_demo`.
 * No muta nada si no es demo.
 */
export function onDemoProductImageError(event, business) {
  if (!business?.is_demo) return;
  const img = event?.currentTarget;
  if (!img || img.getAttribute('data-demo-img-fallback') === '1') return;
  img.setAttribute('data-demo-img-fallback', '1');
  const next = DEMO_PRODUCT_IMAGE_FALLBACK_URL;
  if (next && img.src !== next) img.src = next;
}

export const DEMO_TAG_LABELS = {
  bestseller: 'Más pedido',
  nuevo: 'Nuevo',
  spicy: 'Picante',
  premium: 'Premium',
};

/** Dirección por defecto en checkout demo si el campo queda vacío (mismo flujo que un pedido real). */
export const DEMO_CHECKOUT_DEFAULT_ADDRESS = 'Av. Providencia 1234, Providencia, Región Metropolitana, Chile';

/** Payload compatible con GET /menu/:business_id del backend (solo frontend demo). */
export const DEMO_BUSINESS = {
  id: DEMO_BUSINESS_ID,
  name: 'Seven Smash House',
  slogan: DEMO_PUBLIC_BRAND.tagline,
  description:
    'Smash al plancha, pan brioche tostado y salsas house. Pedí como en tu local favorito — acá solo vivís la experiencia.',
  slug: DEMO_BUSINESS_ID,
  logo_url: IMG.logo,
  banner_url: IMG.cover,
  primary_color: '#ea580c',
  secondary_color: '#18181b',
  accent_color: '#f59e0b',
  whatsapp: '56900000000',
  is_demo: true,
  is_active: true,
  is_open: true,
  closed_message: 'En esta vista previa el local siempre aparece abierto.',
  /** Mismo flujo que un local real: delivery + retiro + mesa (QR ?mesa=) */
  service_types: ['delivery', 'retiro', 'mesa'],
  /** Tiempo usado por el checkout real (misma UI) */
  delivery_time: '22–35 min',
  membership_plan: 'starter',
  accepts_cash: true,
  accepts_transfer: true,
  accepts_card: false,
  accepts_mercadopago: false,
  order_tracking_enabled: false,
  has_tables: true,
  instagram_url: '',
  tiktok_url: '',
  facebook_url: '',
  whatsapp_url: '',
  delivery_zones: [],
  menu_theme: 'premium_dark',
};

/** Promociones primero (display_order menor = antes). */
export const DEMO_CATEGORIES = [
  {
    id: 'demo-cat-promos',
    business_id: DEMO_BUSINESS_ID,
    name: 'House deals',
    display_order: 0,
  },
  {
    id: 'demo-cat-hamburguesas',
    business_id: DEMO_BUSINESS_ID,
    name: 'Smash lineup',
    display_order: 1,
  },
  {
    id: 'demo-cat-papas',
    business_id: DEMO_BUSINESS_ID,
    name: 'Sides & fries',
    display_order: 2,
  },
  {
    id: 'demo-cat-bebidas',
    business_id: DEMO_BUSINESS_ID,
    name: 'Drinks',
    display_order: 3,
  },
];

export const DEMO_PRODUCTS = [
  {
    id: 'demo-prod-smash',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-hamburguesas',
    name: 'Classic Smash',
    description:
      'Doble smash sellado, cheddar fundido, pickles y salsa house — el favorito que vuelve una y otra vez.',
    price: 10990,
    final_price: 10990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 1,
    photo_url: IMG.burger1,
    demo_tags: ['bestseller', 'premium'],
    demo_featured: true,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-bacon',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-hamburguesas',
    name: 'Fire Bacon',
    description: 'Doble carne, bacon crocante, cheddar sharp y BBQ ahumada. Picor suave opcional.',
    price: 9990,
    final_price: 9990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 2,
    photo_url: IMG.burger2,
    demo_tags: ['bestseller'],
    demo_featured: true,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-truffle',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-hamburguesas',
    name: 'Truffle Melt',
    description: 'Blend premium, reducción de trufa, rúcula y parmesano — para paladares exigentes.',
    price: 13990,
    final_price: 13990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 3,
    photo_url: IMG.burger3,
    demo_tags: ['premium', 'nuevo'],
    demo_featured: true,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-combo-gamer',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-promos',
    name: 'The Full Stack',
    description: 'Classic Smash + papas cheddar bacon + bebida — energía para toda la noche.',
    price: 16990,
    final_price: 16990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 1,
    photo_url: IMG.combo,
    demo_tags: ['bestseller'],
    demo_featured: true,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-combo-pareja',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-promos',
    name: 'Date Night',
    description: 'Dos burgers a elección + papas para compartir + 2 bebidas. Mood urbano a dos.',
    price: 28990,
    final_price: 28990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 2,
    photo_url: IMG.combo,
    demo_tags: ['premium'],
    demo_featured: true,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-papas-cheddar',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-papas',
    name: 'Rail fries & cheddar',
    description: 'Papas golden, lluvia de cheddar, bacon crispy y cebolla morada.',
    price: 6990,
    final_price: 6990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 1,
    photo_url: IMG.fries,
    demo_tags: ['bestseller'],
    demo_featured: false,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-nuggets',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-papas',
    name: 'Crispy house nuggets',
    description: '8 unidades extra crocantes con dips a elección (BBQ o mayo chipotle).',
    price: 5990,
    final_price: 5990,
    discount_percentage: 0,
    availability: 'active',
    display_order: 2,
    photo_url: IMG.nuggets,
    demo_tags: ['nuevo'],
    demo_featured: false,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-milkshake',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-bebidas',
    name: 'Velvet Oreo shake',
    description: 'Batido cremoso con galleta Oreo, crema chantilly y chips de chocolate.',
    price: 5490,
    final_price: 5490,
    discount_percentage: 0,
    availability: 'active',
    display_order: 1,
    photo_url: IMG.shake,
    demo_tags: ['premium', 'bestseller'],
    demo_featured: false,
    add_ons: [],
    included_items: [],
  },
  {
    id: 'demo-prod-limonada',
    business_id: DEMO_BUSINESS_ID,
    category_id: 'demo-cat-bebidas',
    name: 'Frozen lime & mint',
    description: 'Limón natural, menta fresca y hielo — versión frozen bien refrescante.',
    price: 4490,
    final_price: 4490,
    discount_percentage: 0,
    availability: 'active',
    display_order: 2,
    photo_url: IMG.drink,
    demo_tags: ['nuevo'],
    demo_featured: false,
    add_ons: [],
    included_items: [],
  },
];

export const DEMO_PROMOS = [
  {
    id: 'demo-promo-martes',
    business_id: DEMO_BUSINESS_ID,
    name: 'Martes 2×1 smash',
    description: 'Dos Classic Smash al precio de una — promo de temporada (visualización).',
    is_active: true,
    promo_type: 'bundle',
    special_price: 10990,
    product_ids: ['demo-prod-smash'],
    expires_at: null,
  },
  {
    id: 'demo-promo-streamer',
    business_id: DEMO_BUSINESS_ID,
    name: 'Combo Afterhours',
    description: 'The Full Stack con upgrade de bebida — pensado para picos de tráfico.',
    is_active: true,
    promo_type: 'bundle',
    special_price: 17990,
    product_ids: ['demo-prod-combo-gamer'],
    expires_at: null,
  },
  {
    id: 'demo-promo-estudiante',
    business_id: DEMO_BUSINESS_ID,
    name: 'Bienvenida house',
    description: '10% en Classic Smash o Fire Bacon con credencial — ejemplo de segmentación.',
    is_active: true,
    promo_type: 'percentage',
    discount_percentage: 10,
    product_ids: ['demo-prod-smash', 'demo-prod-bacon'],
    expires_at: null,
  },
  {
    id: 'demo-promo-happy',
    business_id: DEMO_BUSINESS_ID,
    name: 'Golden hour',
    description: '2×1 en Frozen lime & mint de 17 a 19 h — ideal para picos de tráfico.',
    is_active: true,
    promo_type: 'daily',
    special_price: 4490,
    product_ids: ['demo-prod-limonada'],
    expires_at: null,
  },
];

export function isDemoBusinessId(businessId) {
  return String(businessId || '').trim().toLowerCase() === DEMO_BUSINESS_ID;
}

function byId(products, id) {
  return products.find((p) => p.id === id) || null;
}

export function getDemoMenuPayload() {
  return {
    business: { ...DEMO_BUSINESS },
    categories: DEMO_CATEGORIES.map((c) => ({ ...c })).sort(
      (a, b) => (a.display_order ?? 0) - (b.display_order ?? 0)
    ),
    products: DEMO_PRODUCTS.map((p) => ({ ...p })),
    promos: DEMO_PROMOS.map((p) => ({ ...p })),
    daily_deal_product: null,
    hidden_promo_product: null,
  };
}

/**
 * Respuestas simuladas estilo vendedor (sin IA remota). Compatible con dispatchFreeTextAnswer.
 */
export function buildDemoAssistantFreeTextAnswer(menuData, userQuestion) {
  const q = String(userQuestion || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
  const products = menuData?.products || [];
  const smash = byId(products, 'demo-prod-smash');
  const bacon = byId(products, 'demo-prod-bacon');
  const truffle = byId(products, 'demo-prod-truffle');
  const papas = byId(products, 'demo-prod-papas-cheddar');
  const comboG = byId(products, 'demo-prod-combo-gamer');
  const comboP = byId(products, 'demo-prod-combo-pareja');
  const shake = byId(products, 'demo-prod-milkshake');
  const limonada = byId(products, 'demo-prod-limonada');
  const nuggets = byId(products, 'demo-prod-nuggets');

  const upsellPapas =
    '¿Sumamos Rail fries & cheddar? Van perfectas con cualquier smash 🔥';
  const upsellBebida = '¿Te anoto un Velvet Oreo shake o un Frozen lime & mint para cerrar?';

  if (/\b(papa|papas|frita|acompa|extra)\b/.test(q)) {
    return {
      text: `${upsellPapas}\n\nSon las más pedidas junto al Classic Smash.`,
      products: papas ? [papas] : [],
      suggestedProducts: smash ? [smash] : [],
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(combo|pareja|dupla|full|stack)\b/.test(q)) {
    return {
      text: 'Los combos que más piden: The Full Stack para uno intenso, Date Night para compartir. ¿Cuál te tinca más?',
      products: [comboG, comboP].filter(Boolean),
      suggestedProducts: papas ? [papas] : [],
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(picante|spicy|fuerte)\b/.test(q)) {
    return {
      text: 'Para algo con actitud: Truffle Melt o Fire Bacon con rail fries. Si querés ir full, The Full Stack va como piña.',
      products: [truffle, bacon].filter(Boolean),
      suggestedProducts: [comboG, papas].filter(Boolean),
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(recomienda|suger|que\s+pedir|indecis|no\s+se)\b/.test(q)) {
    return {
      text: 'Los clientes suelen pedir Classic Smash + Rail fries & cheddar. Es el dúo que más convierte. ¿Te los dejo armados?',
      products: [smash, papas].filter(Boolean),
      suggestedProducts: [shake].filter(Boolean),
      textAfterProducts: upsellBebida,
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(burger|hamburg|carne|smash)\b/.test(q)) {
    return {
      text: 'Tenemos Classic Smash (top ventas), Fire Bacon (BBQ y bacon) y Truffle Melt si querés subir el nivel.',
      products: [smash, bacon, truffle].filter(Boolean),
      suggestedProducts: [papas].filter(Boolean),
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(nugget|pollo)\b/.test(q)) {
    return {
      text: 'Los Crispy house nuggets van perfectos para picar. ¿Sumamos un Frozen lime & mint?',
      products: nuggets ? [nuggets] : [],
      suggestedProducts: [limonada].filter(Boolean),
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(shake|batido|oreo|dulce|helado)\b/.test(q)) {
    return {
      text: 'El Velvet Oreo shake es el postre que más piden después del combo. ¿Lo agregamos?',
      products: shake ? [shake] : [],
      suggestedProducts: [comboG].filter(Boolean),
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }
  if (/\b(limonada|bebida|refresco|tomar)\b/.test(q)) {
    return {
      text: 'Para acompañar: Frozen lime & mint bien refrescante o Velvet Oreo shake si querés algo cremoso.',
      products: [limonada, shake].filter(Boolean),
      suggestedProducts: [smash].filter(Boolean),
      frustrationLevel: 0,
      containmentIncluded: true,
      fallbackKeys: [],
    };
  }

  return {
    text: '¡Dale! Muchos eligen Classic Smash con rail fries y un shake. ¿Te armo ese pedido o preferís ver combos?',
    products: [smash, papas].filter(Boolean),
    suggestedProducts: [comboG, shake].filter(Boolean),
    textAfterProducts: 'Decime si querés algo picante o sin carne y te ajusto la sugerencia.',
    frustrationLevel: 0,
    containmentIncluded: true,
    fallbackKeys: [],
  };
}

/** Prefijo de saludo para Assistant en modo demo */
export const DEMO_ASSISTANT_INTRO =
  'Vista previa SoluQR — acá simulamos el chat; los pedidos no salen al restaurante.\n\n';

export const DEMO_ASSISTANT_HINTS =
  'Probá: «¿Qué me recomendás?», «Quiero papas» o «Algo picante».\n\n';
